import styles from "./Badge.module.scss";

export type BadgeVariant =
  | "primary"
  | "success"
  | "warning"
  | "danger"
  | "outline";

interface BadgeProps {
  children: React.ReactNode;
  variant?: BadgeVariant;
  className?: string;
}

/**
 * Badge component for displaying categorical information
 */
export const Badge = ({
  children,
  variant = "primary",
  className = "",
}: BadgeProps) => {
  return (
    <span className={`${styles.badge} ${styles[variant]} ${className}`}>
      {children}
    </span>
  );
};
